import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './services/router/router';
import store from './store/store';
import { VueMaskDirective } from 'v-mask';
import '../semantic/dist/semantic.min.css';
import titleMixin from '@/utils/mixins/title-mixin';
import VueGtag from 'vue-gtag';
import Amplify from '@aws-amplify/core';
import config from './services/cognito/aws-exports';

Vue.config.productionTip = false;

Vue.directive('mask', VueMaskDirective);

Vue.mixin(titleMixin);

Vue.use(VueGtag, {
  config: { id: 'UA-190049508-1' },
}, router);

Amplify.configure(config);

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit('initDownloadQueue');
  },
  render: h => h(App),
}).$mount('#app');
